import React from 'react';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import useHomeContext from 'Context/HomeContext';
import ChangePasswordButton from './ChangePasswordButton';

const ChangePasswordButtonPicker = ({
  ...rest
}) => {
  const { homeResource } = useHomeContext();

  return pickFunction(homeResource, {
    [fr.relationships.resetPassword.name]: () => {
      return (
        <ChangePasswordButton {...rest} />
      );
    },
    [fr.relationships.default.name]: () => null,
  });
};

export default ChangePasswordButtonPicker;
